import get from 'lodash/get';
// import { getArrivalKey } from '../../../utils/cookie';

export const getShowSSOModal = state => get(state, 'application.ssoModal.showModal', false);

export const getIsNavCollapsed = state => get(state, 'application.isCollapsed', false);

export const getSSOProps = state => get(state, 'application.ssoModal.props');

export const getIsPolicyAccepted = state => get(state, 'application.hasAcceptedAgreement', true);

export default {
  getShowSSOModal,
  getSSOProps,
  getIsPolicyAccepted,
  getIsNavCollapsed,
};
